export { default } from './RegisWall';
